import { Button } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import SingleSelectButtonGroup from './SingleSelectButtonGroup';



const defaultButtonTitleValues = [
    {title:'Yes',value:true},
    {title:'No',value:false}
];



const Container = styled.div`
  display:flex;
  justify-content: space-between;
  text-align:center;
  align-items:center;
`;



const FormikButtonsQuestion = ({value,setFieldValue,setFieldTouched,field,buttonTitleValues=defaultButtonTitleValues,onValueChanged,pillStyling=false}) => {
  
    let buttons = buttonTitleValues.map(titleValue => <Button variant="outlined" key={titleValue.value} value={titleValue.value}>{titleValue.title}</Button>);

    return(
            <Container>
                <SingleSelectButtonGroup
                    pillStyling
                    value={value} 
                    onValueChanged={value=>{
                        setFieldValue(field,value);
                        setFieldTouched(field);

                        if ( onValueChanged ) {
                            onValueChanged(value);
                        }
                    }}
                >
                {buttons}
                </SingleSelectButtonGroup>
            </Container>
            
    );
  }

  export default FormikButtonsQuestion;
